const defaultState = {
  error: null
};

const errorReducer = (state = defaultState, action) => {
  if (action.type.endsWith('_REJECTED')) {
    return {
      ...state, error: action.payload
    };
  } else if (action.type === 'ERROR_DIALOG_CLOSED') {
    return {
      ...state, error: null
    };
  } else if (action.type.endsWith('_FULFILLED')) {
    return {
      ...state, error: null
    };
  } else if (action.type === 'SHOW_ERROR_DIALOG') {
    return {
      ...state, error: action.payload
    };
  }

  return state;
};

export default errorReducer;


// WEBPACK FOOTER //
// ./src/reducers/errorReducer.js